import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { endOfYear, getDayOfYear, startOfYear } from "date-fns";
import { useOcCalendar } from "oc/hooks";

interface MyTimesheetCalendarDateHeaderProps {
  date: Date;
  label: string;
}

export const MyTimesheetCalendarDateHeader = (
  props: MyTimesheetCalendarDateHeaderProps,
) => {
  const theme = useTheme();
  const { date, label } = props;
  let startDate = startOfYear(date);
  let endDate = endOfYear(date);

  const { data: Calendar } = useOcCalendar({ startDate, endDate });
  let day = getDayOfYear(date);
  let dayState = Calendar?.charAt(day - 1);

  return (
    <Box paddingRight="8px">
      <Typography
        variant="body1"
        style={{
          padding: 0,
          margin: 0,
          lineHeight: "16px",
          color: dayState === "F" ? theme.palette.primary.main : undefined,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default MyTimesheetCalendarDateHeader;
